exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ref-logs-table tfoot th{border-top:2px solid #e7eaec;background:#f7f9fa;font-weight:600}.barcode-wrapper>:first-child,.qrcode-wrapper>:first-child{font-size:22px}.qrcode-svg svg{width:150px;height:auto}.codes-row .barcode-wrapper,.codes-row .qrcode-wrapper{max-width:61mm;margin-left:auto;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2ae253c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Reference/ReferenceDetail.vue
// module id = 888
// module chunks = 0